<script lang="ts" context="module">
	export type Category = 'credito-habitacao' | 'seguros' | 'simuladores';
</script>

<script lang="ts">
	import { page } from '$app/stores';
	import credHabitacaoSm from '$lib/assets/images/blog/cred_habitacao_banner-small.webp';
	import credHabitacao from '$lib/assets/images/blog/cred_habitacao_banner.webp';
	import lifeInsuranceSm from '$lib/assets/images/blog/life_insurance_banner-small.webp';
	import lifeInsurance from '$lib/assets/images/blog/life_insurance_banner.webp';
	import simulatorsSm from '$lib/assets/images/blog/simuladores_banner-small.webp';
	import simulators from '$lib/assets/images/blog/simuladores_banner.webp';
	import __ from '$lib/stores/TranslationStore';

	export let category: Category = 'simuladores';
	let className: string = '';
	export { className as class };
	export let small: boolean = false;

	type BannerData = { img: string; url: string; desc: string };

	const bannerMap: { [key in Category]: BannerData } = {
		'credito-habitacao': {
			desc: $__('Crédito habitação'),
			img: !small ? credHabitacao : credHabitacaoSm,
			url: '/simuladores'
		},
		seguros: {
			desc: $__('Seguros'),
			img: !small ? lifeInsurance : lifeInsuranceSm,
			url: '/simuladores'
		},
		simuladores: {
			desc: $__('Simuladores'),
			img: !small ? simulators : simulatorsSm,
			url: '/simuladores'
		}
	};
</script>

{#if $page.data?.language === 'pt'}
	<a class={className} href={bannerMap[category].url} target="_blank" id="osnossos_simuladores">
		<img
			src={bannerMap[category].img}
			width="300"
			height={!small ? 600 : 250}
			class="w-full"
			alt={bannerMap[category].desc}
			loading="lazy"
		/>
	</a>
{/if}
